import { JourneyDataModel } from '../../../services/redux/features/journeyData.slice';
import { EmploymentDetailsFormModel_MX } from './formModel';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const requestMapper = (values: EmploymentDetailsFormModel_MX): Partial<JourneyDataModel> => {
  return {};
};
